import * as React from "react";
import {
  Edit,
  SimpleForm,
  NumberInput,
  SaveButton,
  Toolbar,
} from "react-admin";
import { Box } from "@mui/material";

const ShippingRatesEditToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);

const ShippingRatesEdit = () => (
  <Edit id="1" resource="shipping-rates" title="運費設定" redirect="edit">
    <SimpleForm toolbar={<ShippingRatesEditToolbar />}>
      <NumberInput source="fee" label="運費" isRequired />
    </SimpleForm>
  </Edit>
);

export default ShippingRatesEdit;